module.exports = __webpack_public_path__ + "img/segments.de0feed1.png";